window.app = {
    modules: [],

    add: function (module) {
        this.modules.push(module);
        if (module.init) {
            module.init(this);
        }
    },

    notify: function(event, options){
        var method = 'on'.concat(event.charAt(0).toUpperCase(), event.slice(1));
        var i = this.modules.length;
        while (i--){
            var module = this.modules[i];
            if (module[method]) {
                module[method](this, options);
            }
        }
    },

    run: function(){
        if (!window.jQuery) {
            return document.getElementById('jquery-script').addEventListener('load', app.run);
        }
        if (!jQuery.prototype.velocity && !/velocity/.test(this.url)) {
            return $.getScript("//cdn.jsdelivr.net/velocity/1.2.3/velocity.min.js", app.run);
        }
        app.notify('load');
    }
};










// WEBPACK FOOTER //
// ./resources/assets/js/app/app.js